export function extractMatchingData(
  data: Record<string, any>,
  keys: string[]
): Record<string, any> {
  const matchingData: Record<string, any> = {};

  keys.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      matchingData[key] = data[key];
    }
  });

  return matchingData;
}
